import {useMutation} from '@apollo/client'
import {useIntl} from 'react-intl'
import {DEDUCTION_TYPE_MESSAGES as M} from '../deductionTypeMessages'
import React, {useEffect} from 'react'
import {Button, Modal, Spinner} from 'react-bootstrap'
import {toast} from 'react-toastify'
import {parseId} from '../../../helpers'
import { DELETE_USER_DEDUCTION } from '../../../gql/mutations/userMutations'
import { IResDeleteCommisionDeductionTypes, IResDeleteCommissionUserDeduction } from '../../../types/users'
import { DELETE_USER_DEDUCTION_TYPE } from '../../../gql/mutations/userDeductionType'

interface IModalDeleteDeductionTypeProps {
  isOpen: boolean
  onClose: () => void
  refetch: () => void
  infoEdit: {id: string}
}

export const ModalDeleteDeductionType: React.FC<IModalDeleteDeductionTypeProps> = ({
  infoEdit,
  isOpen,
  onClose,
  refetch,
}) => {
  const intl = useIntl()
  const [gqlDeleteCommissionRate, {data, loading, error}] =
    useMutation<IResDeleteCommisionDeductionTypes>(DELETE_USER_DEDUCTION_TYPE)

  useEffect(() => {
    if (error) toast.error(intl.formatMessage(M.errorWithMessage, {message: error.message}))
  }, [error])

  useEffect(() => {
    if (!data) return

    const res = data.CommissionDeductionTypeDelete

    if (res?.success) {
      toast.success(intl.formatMessage(M.toastDeleted))
      onClose()
      refetch()
    } else if (res?.errors && res.errors.length > 0) {
      toast.error(
        intl.formatMessage(M.errorWithMessage, {
          message: res.errors[0]?.message || intl.formatMessage(M.somethingHappened),
        })
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const handleDelete = () => {
    gqlDeleteCommissionRate({
      variables: {
        id: parseId(infoEdit.id),
      },
    })
  }
  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{intl.formatMessage(M.deleteTitle)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4 className='text-primary'>{intl.formatMessage(M.confirmDeleteRecord)}</h4>
      </Modal.Body>
      <Modal.Footer>
        <Button size='sm' variant='secondary' onClick={onClose}>
          {intl.formatMessage(M.cancel)}
        </Button>
        <Button
          size='sm'
          variant='danger'
          className='d-flex align-items-center'
          disabled={loading}
          onClick={handleDelete}
        >
          {loading && <Spinner animation='border' size='sm' />}
          {intl.formatMessage(M.delete)}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
